import { connect } from 'react-redux';

import SubmenuItem from './desktop.submenu_dropdown.jsx';

import {
  executeMatchedRouteIfSameHashOnMenuItemClick
} from 'zoomforth_codesbane_viewer/lib/backbone_history_utils.js';
import { getTracker } from 'zoomforth_codesbane_viewer/lib/global_store.js';

const mapStateToProps = () => {
  return {};
};

const mapDispatchToProps = () => ({
  onDropdownSubmenuItemClick: (submenuItem)=> { 
    getTracker().handleNavMenuItemClick(submenuItem, /* isInDropdown = */ true);
    executeMatchedRouteIfSameHashOnMenuItemClick(submenuItem);
  }
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SubmenuItem);
